module.exports = __webpack_public_path__ + "static/media/50k.3654ba9e.webp";